export const HOMEPAGE = () => `/home`;
